import { render } from "./BattlesGameElement.vue?vue&type=template&id=29ae1474&scoped=true"
import script from "./BattlesGameElement.vue?vue&type=script&lang=js"
export * from "./BattlesGameElement.vue?vue&type=script&lang=js"

import "./BattlesGameElement.vue?vue&type=style&index=0&id=29ae1474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ae1474"]])

export default __exports__